
import { defineComponent } from "vue";
import userWeatherStore from "@/store/weather";
import moment from "moment";
import { mande } from "mande";
import userLocationStore from "@/store/location";
export default defineComponent({
  setup() {
    const weatherStore = userWeatherStore();
    const locationInfo = userLocationStore();
    return {
      weatherStore,
      locationInfo,
    };
  },
  created() {
    this.getDefaultWeather();
  },
  name: "WeatherVue",
  methods: {
    getIcon(description: string) {
      if (description.toLowerCase() === "clear sky")
        return require(`@/assets/sun.png`);

      if (/snow/gi.test(description)) {
        return require(`@/assets/snow.png`);
      }
      if (/rain/gi.test(description)) {
        return require(`@/assets/heavy_rain.png`);
      }
      if (/clouds/gi.test(description)) {
        return require(`@/assets/scattered_clouds.png`);
      }
      if (/fog/gi.test(description)) {
        return require(`@/assets/fog.png`);
      }
    },
    getDay(date: string) {
      return moment(date).format("dddd");
    },
    async getDefaultWeather() {
      try {
        interface keyShape {
          data: Array<any>;
        }
        const key: keyShape = await mande(
          `https://api.weatherbit.io/v2.0/forecast/daily?city=${this.locationInfo.city}&days=7&key=${this.locationInfo.accuWeather}`
        ).get("");
        this.weatherStore.setForecast(key.data);
      } catch (error) {
        console.log(error);
      }
    },
  },
});
